<template>
  <div>
    <header class="maui-bar aui-bar aui-bar-nav">
      <div class="aui-title">求购信息</div>
      <a class="aui-pull-right aui-btn" href="javascript:void(0);" @click="supplyclose">
        <span class="aui-iconfont aui-icon-close aui-icon-right"></span>
      </a>
    </header>
    <div class="maui-search aui-searchbar">
      <div class="aui-searchbar-input aui-border-radius">
        <form action="javascript:search();">
          <input
            type="search"
            placeholder="请输入搜索内容"
            id="search-input"
            v-model="kyeWord"
            ref="gain"
            autofocus
          />
        </form>
        <div class="aui-searchbar-cancel" @click="onserach">
          <button type="submit" class="btn btn-default">
            <i class="aui-iconfont aui-icon-search"></i>
          </button>
        </div>
      </div>
    </div>
    <i class="el-icon-bank-card"></i>
  </div>
</template>

<script>
export default {
  data() {
    return { kyeWord: "" };
  },

  created() {
    this.$nextTick(() => {
      this.$refs.gain.focus();
    }, 100);
  },
  methods: {
    supplyclose() {
      this.$router.push("/purchasing");
    },
    onserach() {
      if (this.kyeWord == "") {
        this.$message({
          message: "请输入您想搜索的内容！",
          type: "warning"
        });
      } else {
        this.$emit("isskeyword", this.kyeWord);

        this.$router.push("/searchpurchasingList");
      }
    }
  }
};
</script>

<style scoped>
.el-icon-bank-card {
  font-size: 12em;
  color: #e4e0e0ef;
}
.maui-bar.aui-bar-nav {
  background-color: #fff;
  color: #000;
  border-bottom: solid 0.1rem #efefef;
}
.aui-label-outlined.aui-label-danger,
.aui-label-outlined.aui-label-danger::after {
  border: solid 0.1rem #c9eee1;
  color: #3bb18a;
}
.aui-bar-nav .aui-btn .aui-iconfont {
  color: #000;
  font-weight: bold;
}
.aui-list {
  background: none;
}
.aui-list .aui-list-item-title.maui-news-tit {
  height: 2rem;
  line-height: 1rem;
  font-size: 0.75rem;
  color: #4f4f4f;
  overflow: hidden;
}
.aui-list .aui-list-item-text.maui-data {
  font-size: 0.65rem;
  margin: 0.2rem 0;
  color: #4f4f4f;
  justify-content: flex-end;
}

.aui-media-list .aui-list-item-inner.maui-supply-rightbox {
  border-bottom: solid 0.05rem #e0e0e0;
  /* padding: 0;
  margin: 0.7rem 0.75rem 0.7rem 0.2rem; */
}
.aui-list .aui-list-item-media.maui-supply-media {
  width: 4.75rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.aui-list .aui-list-item-media.maui-supply-media img {
  width: 4rem;
  height: 5rem;
  border-radius: 0.2rem;
  border: solid 0.05rem #e0e0e0;
}

.aui-list .aui-list-item-text.maui-flex-start {
  justify-content: flex-start;
  margin-bottom: 0.2rem;
}
.maui-search.aui-searchbar {
  background-color: #fff;
}
.maui-search .aui-searchbar-input {
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  border-radius: 0.75rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.maui-search .aui-searchbar-cancel {
}
.maui-search button {
  background: none;
  border: none;
  cursor: pointer;
}
.maui-goods-name {
  font-size: 0.75rem;
  color: #4f4f4f;
  margin-right: 0.5rem;
}
.maui-goods-class {
  font-size: 0.65rem;
  color: #1b8ae0;
  border: solid 0.05rem #;
}
.maui-goods-price {
  font-size: 0.65rem;
  color: #4f4f4f;
  margin-right: 0.5rem;
}
.maui-goods-l {
  font-size: 0.65rem;
  color: #1b8ae0;
  border: solid 0.05rem #1b8ae0;
  padding: 0 0.2rem;
  border-radius: 0.2rem;
}
.maui-goods-l2 {
  font-size: 0.65rem;
  color: #4f4f4f;
}
.aui-list .aui-list-item-text.maui-goods-thredbox i {
  font-size: 0.6rem;
  color: #4f4f4f;
}
.maui-goods-ad {
  font-size: 0.6rem;
  color: #4f4f4f;
}
.maui-goods-ad i {
  font-size: 0.6rem;
  color: #000;
  margin-right: 0.2rem;
}
.maui-goods-data {
  font-size: 0.6rem;
  color: #4f4f4f;
}

.aui-list .aui-list-item {
  background: none;
  border: none;
}

@media only screen and (max-width: 768px) {
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 480px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 49%;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 320px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 40%;
    font-size: 0.6rem;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 70%;
    font-size: 0.6rem;
  }
  .aui-input,
  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  textarea {
    font-size: 0.6rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/purchasingsearch.vue